import { render } from "./AddGhostModal.vue?vue&type=template&id=27c4b78e"
import script from "./AddGhostModal.vue?vue&type=script&lang=js"
export * from "./AddGhostModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__